import LottieComponent from "@/components/lottie-animations/LottieComponent";
import ItemOfferCard from "./ItemOfferCard";
import { Button, EmptyState, PageContainer } from "@/components/ui";
import { staggerDelay } from "@/lib/motion";
import type { ItemOffer } from "@/types";
import type { ReactNode } from "react";

/** Props of `CategoryItemGrid`; `empty` renders inside the grid when `offers` is empty (a `SearchEmpty`). */
export type CategoryItemGridProps = {
  offers: ItemOffer[];
  onItemClick: (itemId: string) => void;
  hideQuantityButton?: boolean;
  empty?: ReactNode;
};

const MIN_BOTTOM_CLEARANCE_PX = 40;

/** Two-column item grid of a category screen: staggered entrance and bottom inset for the fixed chrome. */
export function CategoryItemGrid({ offers, onItemClick, hideQuantityButton = false, empty }: CategoryItemGridProps) {
  return (
    <PageContainer
      bottom="chrome"
      bottomMin={MIN_BOTTOM_CLEARANCE_PX}
      className="grid gap-4 md:grid-cols-2"
    >
      {offers.length > 0
        ? offers.map((itemOffer, index) => (
            <div
              key={itemOffer.id}
              className="h-full animate-item-entrance opacity-0"
              style={{ animationDelay: staggerDelay(index) }}
            >
              <ItemOfferCard
                itemOffer={itemOffer}
                status="AVAILABLE"
                disabled={false}
                index={index}
                itemOffers={offers}
                handleItemClick={onItemClick}
                itemId={itemOffer.id}
                hideQuantityButton={hideQuantityButton}
              />
            </div>
          ))
        : empty}
    </PageContainer>
  );
}

/** Full-height notice of a category without available products, with a way back. */
export function CategoryEmptyState({ onBack }: { onBack: () => void }) {
  return (
    <PageContainer className="h-full">
      <EmptyState
        size="section"
        className="h-full justify-center"
        illustration={<LottieComponent />}
        title="Essa categoria ainda não possui produtos disponíveis."
        action={
          <Button size="lg" fullWidth onClick={onBack}>
            Voltar
          </Button>
        }
      />
    </PageContainer>
  );
}
